import React from "react";

import AcceptableUsePolicyPage from "@/pages/AcceptableUsePolicy/AcceptableUsePolicyPage";

export default function Layout(): React.JSX.Element {
  return <AcceptableUsePolicyPage />;
}
